'use client';

import { QRCodeSVG } from 'qrcode.react';
import { AppOverlayPortal } from './app-overlay-portal';

export function MemberQrCard({ token, memberName, memberCode, onClose }: { token: string; memberName: string; memberCode: string; onClose: () => void }) {
  const value = `miniapp-member:${token}`;
  return <AppOverlayPortal><div className="member-qr-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
    <section className="member-qr-sheet" role="dialog" aria-modal="true" aria-labelledby="member-qr-title">
      <button type="button" className="member-qr-close" onClick={onClose} aria-label="關閉">×</button>
      <span className="hero-kicker">MEMBER ID</span>
      <h2 id="member-qr-title">我的會員 QR Code</h2>
      <p>上課後購買方案時，請讓老師掃描此畫面。QR Code 只會帶入你的會員身分，不包含付款資料。</p>
      <div className="member-qr-code"><QRCodeSVG value={value} size={220} level="M" /></div>
      <strong>{memberName}</strong>
      <div className="member-code"><span>會員代號</span><b>{memberCode}</b></div>
      <small>為保障帳號安全，本 QR Code 會定期更新。</small>
    </section>
  </div></AppOverlayPortal>;
}
